import { gql } from '@apollo/client';

/**
 * Paginated rows: `pageInfo` omits `totalCount` so the API skips the expensive count (selection-set driven).
 * Use HASHES_TOTAL_COUNT when you need the total row count.
 */
export const HASHES_LIST = gql`
  query hashesList($args: HashesInput!) {
    hashes(args: $args) {
      pageInfo {
        startCursor
        endCursor
      }
      edges {
        cursor
        node {
          hash
          type
          hashType
          cracked
          numRounds
          filePath
          hashcatNumber
          correlations {
            assetName
            assetId
          }
        }
      }
    }
  }
`;

/** Same `HashesInput` as the list; selection includes only `pageInfo { totalCount }`. */
export const HASHES_TOTAL_COUNT = gql`
  query hashesTotalCount($args: HashesInput!) {
    hashes(args: $args) {
      pageInfo {
        totalCount
      }
    }
  }
`;

/** Alias of HASHES_LIST for refetchQueries and existing imports (e.g. PDF report). */
export const HASHES = HASHES_LIST;
